import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Default SEO values (fallback)
const DEFAULT_SEO = {
  servicos: {
    title_pt: "Serviços | Your Broker Portugal – Consultoria Imobiliária",
    title_en: "Services | Your Broker Portugal – Real Estate Consultancy",
    description_pt: "Consultoria imobiliária para compradores e investidores em Portugal: pesquisa de mercado, negociação, suporte jurídico e acompanhamento até a escritura.",
    description_en: "Real estate consultancy for buyers and investors in Portugal: market research, negotiation, legal support and guidance until the deed."
  },
  regioes: {
    title_pt: "Regiões | Onde Atuamos em Portugal – Your Broker Portugal",
    title_en: "Regions | Where We Operate in Portugal – Your Broker Portugal",
    description_pt: "Lisboa, Cascais, Comporta e outras regiões premium. Descubra as melhores zonas para viver e investir com suporte completo.",
    description_en: "Lisbon, Cascais, Comporta and other premium regions. Discover the best areas to live and invest with complete support."
  },
  sobre: {
    title_pt: "Sobre | Your Broker Portugal – Todas as Agências Numa Só",
    title_en: "About | Your Broker Portugal – All Agencies in One",
    description_pt: "Conheça o modelo 'Todas as Agências Numa Só': representação estratégica do comprador com acesso a todo o mercado português.",
    description_en: "Learn about the 'All Agencies in One' model: strategic buyer representation with access to the entire Portuguese market."
  },
  blog: {
    title_pt: "Blog | Your Broker Portugal – Dicas e Insights Imobiliários",
    title_en: "Blog | Your Broker Portugal – Real Estate Tips and Insights",
    description_pt: "Artigos, guias e insights sobre o mercado imobiliário português. Dicas para compradores, investidores e quem quer viver em Portugal.",
    description_en: "Articles, guides and insights about the Portuguese real estate market. Tips for buyers, investors and those who want to live in Portugal."
  },
  contacto: {
    title_pt: "Contacto | Agendar Consulta Estratégica – Your Broker Portugal",
    title_en: "Contact | Schedule Strategic Consultation – Your Broker Portugal",
    description_pt: "Agende uma consulta estratégica para comprar ou investir em Portugal. Atendimento personalizado e orientação completa.",
    description_en: "Schedule a strategic consultation to buy or invest in Portugal. Personalized service and complete guidance."
  }
};

export const usePageSEO = (page, language = 'pt') => {
  const [seo, setSeo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/seo/${page}`);
        setSeo(response.data);
      } catch (error) {
        console.error('Error fetching SEO:', error);
        // Use default SEO on error
        setSeo({ page, ...DEFAULT_SEO[page] });
      } finally {
        setLoading(false);
      }
    };

    if (page && DEFAULT_SEO[page]) {
      fetchSEO();
    } else {
      setLoading(false);
    }
  }, [page]);

  const getTitle = () => {
    if (!seo) return DEFAULT_SEO[page]?.[`title_${language}`] || '';
    return seo[`title_${language}`] || seo.title_pt || '';
  };

  const getDescription = () => {
    if (!seo) return DEFAULT_SEO[page]?.[`description_${language}`] || '';
    return seo[`description_${language}`] || seo.description_pt || '';
  };

  return {
    title: getTitle(),
    description: getDescription(),
    loading
  };
};

export default usePageSEO;
